import _ from 'lodash';
import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import moment from 'moment-timezone';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { getGlobalClasses } from '../../themes';
import genericPlusIcon from "../../images/icons/genericPlus.svg";
import SavingDialog from '../../components/dialogs/SavingDailog';

import AdminContainer from '../../containers/Admin';
import TimeClockLocationSelect from '../../components/advancedForm/TimeClockLocationSelect';
import FormComponent from '../../components/FormComponent';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		pickerCardPaper : {
			height : '100%',
		},
		pickerCardPadding : {
			padding : 30,
		},
		pickCardTitleContainer : {
			paddingTop : 10,
			display : 'flex',
			alignContent : 'center',
			alignItems: 'center',
			paddingBottom : 30,
		},
		pickerCardTitle : {
			paddingLeft : 10,
			fontSize : 28,
			color : '#333',
		},
		driverReportIcon : {
			width : 50,
		},
		pickerCardDescriptionLabel : {
			textTransform : 'uppercase',
			color : '#999',
			fontSize : 16,
		},
		pickerCardDescription : {
			fontSize : 18,
		},
		locationRequired : {
			marginTop : 10,
			marginBottom : 10,
			fontSize : 18,
			backgroundColor : '#f7f7f7',
			border: `1px solid #ddd`,
			padding : 15,
		},
		pickerCardButtonContainer : {
			textAlign : 'right',
			paddingTop : 30,
		},
		pickerCardButton : {
			paddingRight : 55,
			paddingLeft : 55,
			fontSize : 18,
		},

	};
};

class AuthorizeBrowser extends FormComponent {
	constructor(props) {
		super(props);
		const cookies = new Cookies();
		this.state = {
			isSavingOpen : false,
			savingStatus : undefined,
			timeClockLocationId : cookies.get('timeClockLocationId')
		};
	}

	handleAuthorize = () => {
		const { getBrowserAuthCode, showErrors } = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({path, label}) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			return showErrors(_.values(formFieldError));
		}

		this.setState({
			isSavingOpen: true,
			savingStatus : 'saving'
		});

		const { timeClockLocationId } = this.state;

		_.delay(() => {
			getBrowserAuthCode({
				params: {
					timeClockLocationId,
					userAgent: navigator.userAgent
				},
				callback: (err, result) => {
					if (err) {
						this.setState({isSavingOpen: false});
						return showErrors((_.isArray(err)) ? err : [err]);
					}

					const browserAuthCode = _.get(result, 'browserAuthCode');
					if (!browserAuthCode) {
						this.setState({isSavingOpen: false});
						return showErrors('Missing browserAuthCode in result');
					}

					const cookies = new Cookies();
					cookies.set('browserAuthCode', browserAuthCode, {
						path: '/',
						expires: new Date(moment().add(5, 'year').format())
					});

					cookies.set('timeClockLocationId', timeClockLocationId, {
						path: '/',
						expires: new Date(moment().add(5, 'year').format())
					});

					this.setState({savingStatus: 'done'});
				}
			})
		}, 1500);
	};

	closeSavingDialog = () => {
		this.setState({isSavingOpen: false});
	};

	render () {
		const {
			classes,
		} = this.props;

		const {
			isSavingOpen,
			savingStatus,
		} = this.state;

		const title = 'Authorize Browser for Driver Login'
		const description =
			`Click the button below to set a special authorization cookie on this browser ` +
			` that will allow drivers to login from this browser. Note : This does not authorize ` +
			` this computer only this browser. If cookies are cleared it will need to be ` +
			` reauthorized.`

		return (<Fragment>
			<div className={classes.globalMainHeadline}>Admin</div>

			<Grid container spacing={2}>
				<Grid item xs={12} sm={8}>
					<Paper className={classes.pickerCardPaper}>
						<div className={classes.pickerCardPadding}>
							<div className={classes.pickCardTitleContainer}>
								<img
									alt="Action Icon"
									src={genericPlusIcon}
									className={classes.driverReportIcon}
								/>
								<span className={classes.pickerCardTitle}>{title}</span>
							</div>
							<div>
								<div className={classes.pickerCardDescriptionLabel}>
									Description
								</div>
								<div className={classes.pickerCardDescription}>
									{description}
								</div>

								<div className={classes.locationRequired}>
									<strong>Location Required</strong> : When a driver logs in at this browser this is the
									location that will be used when communicating their GPS to GeoTabs for on duty
									and off duty status.
								</div>

								<TimeClockLocationSelect
									{...this.setForm('timeClockLocationId', 'Time Clock Location', true)}
								/>

								<div className={classes.pickerCardButtonContainer}>
									<Button
										variant="contained"
										color="primary"
										aria-label="Add"
										size="large"
										className={classes.pickerCardButton}
										onClick={this.handleAuthorize}
									>
										Authorize Browser
									</Button>
								</div>
							</div>
						</div>
					</Paper>

				</Grid>
			</Grid>

			<SavingDialog
				open={isSavingOpen}
				onClose={this.closeSavingDialog}
				onContinue={this.closeSavingDialog}
				processingText={"Authorizing browser.."}
				successText={"Browser authorized successfully. Thank you."}
				status={savingStatus}
			/>

		</Fragment>);
	}
}

AuthorizeBrowser.propTypes = {
	classes: PropTypes.object.isRequired,
	authUser : PropTypes.object,
	getBrowserAuthCode : PropTypes.func.isRequired,
	showErrors : PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	AdminContainer,
])(AuthorizeBrowser);
